export default function returnYear() {
  let date = new Date();
  let currentYear = date.getFullYear();
  return currentYear;
}
